module.exports = __webpack_public_path__ + "static/media/ReceiptScreen.b3a007b1.png";